import { useState, useEffect, useLayoutEffect } from "react";

export function useWindowSize() {
  const [windowSize, setWindowSize] = useState({
    width: undefined,
    height: undefined
  });
  useEffect(function resize() {
    function handleResize() {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight
      });
    }
    window.addEventListener("resize", handleResize);
    handleResize();
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  return windowSize;
}

export function useResizeObserve(ref) {
  const [size, setSize] = useState({
    width: ref.current ? ref.current.clientWidth : window.innerWidth,
    height: ref.current ? ref.current.clientHeight : window.innerHeight
  });

  useLayoutEffect(
    function resizeEffect() {
      function handleSize() {
        if (ref.current) {
          setSize({
            width: ref.current.clientWidth,
            height: ref.current.clientHeight
          });
        }
      }

      const resizeObserver = new ResizeObserver(handleSize);
      let element = ref.current;
      if (element) {
        resizeObserver.observe(element);
      }
      return () => {
        if (element) {
          resizeObserver.unobserve(element);
        }
      };
    },
    [ref]
  );

  return size;
}
